import { createFileRoute } from "@tanstack/react-router";
import { ConnectHomePage } from "@/app/connect/pages/home";

export const Route = createFileRoute("/connect/insights")({
	component: ConnectHomePage,
});
